var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlantFieldObs = function SvgPlantFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plant-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#E131C2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    d: "M13.5 9.625a.45.45 0 0 0-.084-.26L12.01 7.388c-.465-.654-1.243-1.044-2.08-1.044H7c-.277 0-.5.21-.5.468v5.157h7zm-4 0V7.281h.43c.502 0 .969.235 1.248.627l1.221 1.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    d: "M19 15.719c-.827 0-1.5-.631-1.5-1.406v-2.344c0-.259-.224-.469-.5-.469s-.5.21-.5.469v1.875h-1.278a2.02 2.02 0 0 0-1.722-.938h-7c-1.103 0-2 .841-2 1.875s.897 1.875 2 1.875h7c.93 0 1.706-.6 1.929-1.406h1.283c.387.826 1.265 1.406 2.288 1.406.276 0 .5-.21.5-.468 0-.26-.224-.47-.5-.47m-12 0c-.551 0-1-.42-1-.938 0-.517.449-.937 1-.937.551 0 1 .42 1 .937 0 .517-.449.938-1 .938m3 0c-.552 0-1-.42-1-.938 0-.517.448-.937 1-.937s1 .42 1 .937c0 .517-.448.938-1 .938m3 0c-.552 0-1-.42-1-.938 0-.517.448-.937 1-.937s1 .42 1 .937c0 .517-.448.938-1 .938"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plant-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPlantFieldObs;